"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarTickWithSelected = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var SELECTED_PILL_WIDTH = 84;
var SELECTED_PILL_HEIGHT = 22;
var SELECTED_TEXT = "selected";
function BarTickWithSelected(_a) {
    var tickProps = _a.tickProps, tickGap = _a.tickGap, data = _a.data;
    var x = tickProps.x, y = tickProps.y, index = tickProps.index;
    var isSelected = data[index].isSelected;
    return (react_1.default.createElement("g", { transform: "translate(".concat(x, ",").concat(y, ")") },
        react_1.default.createElement(kaleidoscope_1.Label, { className: "chart__tick-label", dy: tickGap, element: "text", textAnchor: "middle" }, data[index].xAxisName),
        isSelected && (react_1.default.createElement("rect", { x: -SELECTED_PILL_WIDTH / 2, y: tickGap + 12, width: SELECTED_PILL_WIDTH, height: SELECTED_PILL_HEIGHT, rx: SELECTED_PILL_HEIGHT / 2, stroke: "#B9CCD4", fill: "#fff" })),
        isSelected && (react_1.default.createElement(kaleidoscope_1.Label, { x: 0, y: tickGap + 12 * 2.25, opacity: 0.6, fill: "#B9CCD4", textAnchor: "middle", size: "s", element: "text" }, SELECTED_TEXT))));
}
exports.BarTickWithSelected = BarTickWithSelected;
